'use client';

const WEBVIEW_USER_AGENTS = [
    'instagram',
    'fban',
    'fbav',
    'fb_iab',
    'messenger'
];

export const isWebviewBrowser = (): boolean => {
    if (typeof navigator === 'undefined') return false;
    return WEBVIEW_USER_AGENTS.some(userAgent => navigator.userAgent.toLowerCase().includes(userAgent));
};
